import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "userCreateModal",
  tabindex: "-1",
  "aria-labelledby": "userCreateModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_3 = { class: "modal-content border-0 shadow" }
const _hoisted_4 = { class: "modal-header border-bottom-dashed" }
const _hoisted_5 = { class: "modal-chip" }
const _hoisted_6 = {
  class: "modal-title fw-bold mt-3 mb-1",
  id: "userCreateModalLabel"
}
const _hoisted_7 = { class: "text-muted mb-0" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "modal-body p-4 p-xl-40" }
const _hoisted_10 = { class: "row g-3" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "avatar-panel" }
const _hoisted_13 = { class: "avatar-preview-wrap" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "avatar-meta" }
const _hoisted_16 = { class: "field-header mb-2" }
const _hoisted_17 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_18 = { class: "field-caption" }
const _hoisted_19 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_20 = {
  key: 0,
  class: "text-muted d-block mt-2"
}
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "field-header" }
const _hoisted_23 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_24 = { class: "field-caption" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "field-header" }
const _hoisted_29 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_30 = { class: "field-caption" }
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "field-header" }
const _hoisted_35 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_36 = { class: "field-caption" }
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "field-header" }
const _hoisted_41 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_42 = { class: "field-caption" }
const _hoisted_43 = ["placeholder"]
const _hoisted_44 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_45 = { class: "col-md-6" }
const _hoisted_46 = { class: "field-header" }
const _hoisted_47 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_48 = { class: "field-caption" }
const _hoisted_49 = ["placeholder"]
const _hoisted_50 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = { class: "field-header" }
const _hoisted_53 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_54 = { class: "field-caption" }
const _hoisted_55 = ["placeholder", "required"]
const _hoisted_56 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_57 = { class: "col-md-6" }
const _hoisted_58 = { class: "field-header" }
const _hoisted_59 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_60 = { class: "field-caption" }
const _hoisted_61 = { value: null }
const _hoisted_62 = ["value"]
const _hoisted_63 = { class: "col-md-6" }
const _hoisted_64 = { class: "field-header" }
const _hoisted_65 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_66 = { class: "field-caption" }
const _hoisted_67 = { value: null }
const _hoisted_68 = ["value"]
const _hoisted_69 = { class: "col-md-6" }
const _hoisted_70 = { class: "field-header" }
const _hoisted_71 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_72 = { class: "field-caption" }
const _hoisted_73 = { value: null }
const _hoisted_74 = ["value"]
const _hoisted_75 = { class: "col-md-6" }
const _hoisted_76 = { class: "field-header" }
const _hoisted_77 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_78 = { class: "field-caption" }
const _hoisted_79 = { value: null }
const _hoisted_80 = ["value"]
const _hoisted_81 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_82 = { class: "col-md-6" }
const _hoisted_83 = { class: "field-header" }
const _hoisted_84 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_85 = { class: "field-caption" }
const _hoisted_86 = { value: 1 }
const _hoisted_87 = { value: 0 }
const _hoisted_88 = { class: "col-md-6" }
const _hoisted_89 = { class: "field-header" }
const _hoisted_90 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_91 = { class: "field-caption" }
const _hoisted_92 = { value: 1 }
const _hoisted_93 = { value: 0 }
const _hoisted_94 = { class: "col-md-6" }
const _hoisted_95 = { class: "field-header" }
const _hoisted_96 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_97 = { class: "field-caption" }
const _hoisted_98 = ["placeholder"]
const _hoisted_99 = { class: "col-md-6" }
const _hoisted_100 = { class: "field-header" }
const _hoisted_101 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_102 = { class: "field-caption" }
const _hoisted_103 = ["placeholder"]
const _hoisted_104 = { class: "col-12" }
const _hoisted_105 = { class: "field-header" }
const _hoisted_106 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_107 = { class: "field-caption" }
const _hoisted_108 = ["placeholder"]
const _hoisted_109 = { class: "d-flex justify-content-between align-items-center mt-4 pt-2" }
const _hoisted_110 = {
  type: "button",
  class: "btn btn-light px-4",
  "data-bs-dismiss": "modal"
}
const _hoisted_111 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.user ? _ctx.$t("user_page.edit_user_chip") : _ctx.$t("user_page.new_user")), 1),
            _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.user ? _ctx.$t("user_page.update_user") : _ctx.$t("user_page.create_user")), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("user_page.modal_description")), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close shadow-none",
            "data-bs-dismiss": "modal",
            "aria-label": _ctx.$t('common.close')
          }, null, 8, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("form", {
            onSubmit: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("img", {
                      src: _ctx.previewAvatarUrl,
                      alt: _ctx.$t('user_page.avatar_preview'),
                      class: "avatar-preview"
                    }, null, 8, _hoisted_14)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("user_page.profile_image")), 1),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("user_page.profile_image_caption")), 1)
                    ]),
                    _createElementVNode("input", {
                      ref: "avatarInput",
                      type: "file",
                      class: "d-none",
                      accept: "image/png,image/jpeg,image/jpg,image/gif,image/webp",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleAvatarChange && _ctx.handleAvatarChange(...args)))
                    }, null, 544),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-light px-4 h-45",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openAvatarPicker && _ctx.openAvatarPicker(...args)))
                      }, _toDisplayString(_ctx.$t("user_page.choose_image")), 1),
                      (_ctx.selectedAvatarName)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-outline-secondary px-4 h-45",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedAvatar && _ctx.clearSelectedAvatar(...args)))
                          }, _toDisplayString(_ctx.$t("user_page.remove_image")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.selectedAvatarName)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_20, _toDisplayString(_ctx.$t("user_page.selected_file", { name: _ctx.selectedAvatarName })), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("user_page.first_name")), 1),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("user_page.first_name_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.first_name) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.fieldErrors.first_name }]),
                  placeholder: _ctx.$t('user_page.first_name_placeholder'),
                  required: ""
                }, null, 10, _hoisted_25), [
                  [_vModelText, _ctx.formData.first_name]
                ]),
                (_ctx.fieldErrors.first_name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.fieldErrors.first_name), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("user_page.last_name")), 1),
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("user_page.last_name_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.last_name) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.fieldErrors.last_name }]),
                  placeholder: _ctx.$t('user_page.last_name_placeholder'),
                  required: ""
                }, null, 10, _hoisted_31), [
                  [_vModelText, _ctx.formData.last_name]
                ]),
                (_ctx.fieldErrors.last_name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.fieldErrors.last_name), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("user_page.username")), 1),
                  _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t("user_page.username_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.username) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.fieldErrors.username }]),
                  placeholder: _ctx.$t('user_page.username_placeholder'),
                  required: ""
                }, null, 10, _hoisted_37), [
                  [_vModelText, _ctx.formData.username]
                ]),
                (_ctx.fieldErrors.username)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.fieldErrors.username), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("user_page.email")), 1),
                  _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t("user_page.email_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.email) = $event)),
                  type: "email",
                  class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.fieldErrors.email }]),
                  placeholder: _ctx.$t('user_page.email_placeholder'),
                  required: ""
                }, null, 10, _hoisted_43), [
                  [_vModelText, _ctx.formData.email]
                ]),
                (_ctx.fieldErrors.email)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_ctx.fieldErrors.email), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t("user_page.phone")), 1),
                  _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t("user_page.phone_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.phone) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.fieldErrors.phone }]),
                  placeholder: _ctx.$t('user_page.phone_placeholder'),
                  required: ""
                }, null, 10, _hoisted_49), [
                  [_vModelText, _ctx.formData.phone]
                ]),
                (_ctx.fieldErrors.phone)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.fieldErrors.phone), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t("user_page.password")), 1),
                  _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.user ? _ctx.$t("user_page.password_caption_edit") : _ctx.$t("user_page.password_caption_create")), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.password) = $event)),
                  type: "password",
                  class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.fieldErrors.password }]),
                  placeholder: _ctx.$t('user_page.password_placeholder'),
                  required: !_ctx.user
                }, null, 10, _hoisted_55), [
                  [_vModelText, _ctx.formData.password]
                ]),
                (_ctx.fieldErrors.password)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_ctx.fieldErrors.password), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.$t("user_page.warehouse")), 1),
                  _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$t("user_page.warehouse_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.warehouse_id) = $event)),
                  class: "form-select modal-input"
                }, [
                  _createElementVNode("option", _hoisted_61, _toDisplayString(_ctx.$t("common.none")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (warehouse) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: warehouse.id,
                      value: warehouse.id
                    }, _toDisplayString(warehouse.name), 9, _hoisted_62))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.formData.warehouse_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t("user_page.branch")), 1),
                  _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.$t("user_page.branch_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.branch_id) = $event)),
                  class: "form-select modal-input"
                }, [
                  _createElementVNode("option", _hoisted_67, _toDisplayString(_ctx.$t("common.none")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branches, (branch) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: branch.id,
                      value: branch.id
                    }, _toDisplayString(branch.name), 9, _hoisted_68))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.formData.branch_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t("user_page.biller")), 1),
                  _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$t("user_page.biller_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.biller_id) = $event)),
                  class: "form-select modal-input"
                }, [
                  _createElementVNode("option", _hoisted_73, _toDisplayString(_ctx.$t("common.none")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billers, (biller) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: biller.id,
                      value: biller.id
                    }, _toDisplayString(biller.name), 9, _hoisted_74))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.formData.biller_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.$t("user_page.role_permission")), 1),
                  _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.$t("user_page.role_permission_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.role_permission_id) = $event)),
                  class: _normalizeClass(["form-select modal-input", { 'is-invalid': _ctx.fieldErrors.role_permission_id }])
                }, [
                  _createElementVNode("option", _hoisted_79, _toDisplayString(_ctx.$t("user_page.select_role")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: role.id,
                      value: role.id
                    }, _toDisplayString(role.role_name), 9, _hoisted_80))
                  }), 128))
                ], 2), [
                  [_vModelSelect, _ctx.formData.role_permission_id]
                ]),
                (_ctx.fieldErrors.role_permission_id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_ctx.fieldErrors.role_permission_id), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.$t("user_page.gender")), 1),
                  _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.$t("user_page.gender_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.gender) = $event)),
                  class: "form-select modal-input"
                }, [
                  _createElementVNode("option", _hoisted_86, _toDisplayString(_ctx.$t("user_page.gender_male")), 1),
                  _createElementVNode("option", _hoisted_87, _toDisplayString(_ctx.$t("user_page.gender_female")), 1)
                ], 512), [
                  [_vModelSelect, _ctx.formData.gender]
                ])
              ]),
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("label", _hoisted_90, _toDisplayString(_ctx.$t("user_page.status")), 1),
                  _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.$t("user_page.status_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.active) = $event)),
                  class: "form-select modal-input"
                }, [
                  _createElementVNode("option", _hoisted_92, _toDisplayString(_ctx.$t("user_page.status_active")), 1),
                  _createElementVNode("option", _hoisted_93, _toDisplayString(_ctx.$t("user_page.status_inactive")), 1)
                ], 512), [
                  [_vModelSelect, _ctx.formData.active]
                ])
              ]),
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("label", _hoisted_96, _toDisplayString(_ctx.$t("user_page.company")), 1),
                  _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.$t("user_page.company_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.company) = $event)),
                  type: "text",
                  class: "form-control modal-input",
                  placeholder: _ctx.$t('user_page.company_placeholder')
                }, null, 8, _hoisted_98), [
                  [_vModelText, _ctx.formData.company]
                ])
              ]),
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.$t("user_page.pin_code")), 1),
                  _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.$t("user_page.pin_code_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.pin_code) = $event)),
                  type: "password",
                  class: "form-control modal-input",
                  placeholder: _ctx.$t('user_page.pin_code_placeholder')
                }, null, 8, _hoisted_103), [
                  [_vModelText, _ctx.formData.pin_code]
                ])
              ]),
              _createElementVNode("div", _hoisted_104, [
                _createElementVNode("div", _hoisted_105, [
                  _createElementVNode("label", _hoisted_106, _toDisplayString(_ctx.$t("user_page.address")), 1),
                  _createElementVNode("span", _hoisted_107, _toDisplayString(_ctx.$t("user_page.address_caption")), 1)
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.address) = $event)),
                  rows: "4",
                  class: "form-control modal-input modal-textarea",
                  placeholder: _ctx.$t('user_page.address_placeholder')
                }, null, 8, _hoisted_108), [
                  [_vModelText, _ctx.formData.address]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("button", _hoisted_110, _toDisplayString(_ctx.$t("common.cancel")), 1),
              _createElementVNode("button", {
                type: "submit",
                class: "btn style-one px-4 h-55",
                disabled: _ctx.loading
              }, _toDisplayString(_ctx.loading ? _ctx.$t("user_page.saving") : _ctx.user ? _ctx.$t("user_page.update_user") : _ctx.$t("user_page.create_user")), 9, _hoisted_111)
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}